import { Flower2, Headphones, Home, Monitor, Sparkles, Tag } from 'lucide-react';
import type { Category } from '@pricymayky/shared';

const icons = { headphones: Headphones, monitor: Monitor, home: Home, sparkles: Sparkles };

export function ProductThumb({ category, imageUrl, size = 'md' }: { category: Category; imageUrl: string | null; size?: 'sm' | 'md' | 'lg' }) {
  const Icon = icons[category.icon as keyof typeof icons] ?? (category.slug.includes('miesz') ? Flower2 : Tag);
  const sizes = size === 'sm' ? 'size-10 rounded-lg' : size === 'lg' ? 'size-28 rounded-2xl' : 'size-14 rounded-xl';
  return <div className={`${sizes} relative flex shrink-0 items-center justify-center overflow-hidden border border-border bg-gradient-to-br from-muted to-card text-primary`}>
    {imageUrl ? <img src={imageUrl} alt="" className="size-full object-cover" /> : <Icon className={size === 'lg' ? 'size-11' : 'size-5'} strokeWidth={1.7} />}
  </div>;
}
